import Reflux from 'reflux';

const AlertConditionsActions = Reflux.createActions({
  'available': { asyncResult: true },
  'delete': { asyncResult: true },
  'list': { asyncResult: true },
  'save': { asyncResult: true },
  'update': { asyncResult: true },
});

export default AlertConditionsActions;



// WEBPACK FOOTER //
// ./src/actions/alertconditions/AlertConditionsActions.jsx